import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import FeederHome from "./FeederHome";
import HomeMasterFeeder from "./HomeMasterFeeder";

const Feeder = () => {
  return (
    <div>
      <Routes>
        <Route index element={<FeederHome />} />
        <Route path="homemaster" element={<HomeMasterFeeder />} />
      </Routes>
      <Outlet />
    </div>
  );
};

export default Feeder;
